// extracted by mini-css-extract-plugin
module.exports = {"info-text-box":"InfoTextBox_info-text-box__PA_Qz"};